import ApplicationStyles from 'app/styles/ApplicationStyles';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	root: {
		display: 'flex',
	},
    // appBarSpacer: theme.mixins.toolbar,
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    BreadcrumbsBox: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginTop: '60px',
        marginLeft: '-7px',
        top: '-2px',
        // background: '#fff',
        zIndex: 10,
    },
    HubOptions: {
        background: '#fff',
        padding: '10px 5px 10px 5px',
        borderRadius: '5px',
        width: '100%',
        height: 'auto',
        boxShadow: '0px 2px 1px 0px #ccc'
    },
    select: {
        padding: 5,
    },
	content: {
		flexGrow: 1,
        paddingBottom: 8,
		height: '100vh',
        overflow: 'auto',
	},
}));

export const styles = ({
    ...ApplicationStyles.margins,
    ...ApplicationStyles.flexBox,
	titleBox: {
        ...ApplicationStyles.margins.baseHorizontalMargin,
        ...ApplicationStyles.margins.smallVerticalMargin
    }
})

